<div class="row mx-0" *ngIf="!subscription_cancel && !subscription_restore">
    <div
        class="new-header d-flex align-items-center justify-content-between w-100 px-3 py-3 profile-head common--header">
        <div class="header-content">
            Profile
        </div>
        <div style="position: fixed;right: 0;" class="pe-3">
            <app-notification-icon></app-notification-icon>
        </div>
    </div>

    <div class="col-xl-3 col-lg-4 stick-mod">
        <div class="inner_profile">
            <div class="row">
                <div class="col-12 py-2 text-center text-center">
                    <div class="profile" for="profile-img">
                        <div class="img" *ngIf="UserRole !== 5">
                            <label tappable for="profile-img">
                                <img for="profile-img"
                                    [ngClass]="[selectedProfileImage == 'assets/img/svg/profile-circle.svg' || (!selectedProfileImage.changingThisBreaksApplicationSecurity ? selectedProfileImage.includes('doctor_profile/profile_placeholder.png') : selectedProfileImage.changingThisBreaksApplicationSecurity.includes('doctor_profile/profile_placeholder.png') ) ? 'logo_pro img-fluid rounded-circle rounded form-group' : 'img_pro img-fluid rounded form-group' ]"
                                    [src]="selectedProfileImage" style="max-height:234px !important;" />
                                <div class="edit">
                                    <img src="assets/img/svg/camera.svg" alt="">
                                </div>
                            </label>
                        </div>
                        <div class="profile-info" style="word-break: break-all;" *ngIf="userProfileData">
                            <h3 *ngIf="UserRole !== 5" class="notranslate">{{userProfileData?.doctor_first_name ?
                                userProfileData?.doctor_first_name :
                                userProfileData?.enterprise_first_name}}
                                {{userProfileData?.doctor_last_name ? userProfileData?.doctor_last_name :
                                userProfileData?.enterprise_last_name}}
                            </h3>
                            <h3 *ngIf="UserRole == 5">Hello
                                <span class="notranslate">{{userProfileData?.agent_name}}</span>
                            </h3>
                            <span class="busi-own" *ngIf="UserRole !== 5">{{userProfileData?.ind_name}}</span>
                            <span class="busi-ownmail" *ngIf="UserRole == 5">
                                {{userProfileData?.agent_email}}
                            </span>
                        </div>
                    </div>
                    <!--Edit Image-->
                    <input id="profile-img" type="file" (change)="fileChangeEvent($event)" class="d-none"
                        accept=".png, .jpg, .jpeg" />
                </div>

                <div class="col-12 text-center">
                    <ul class="nav flex-column inner">
                        <li class="nav-item" [class.active-btn]="tab == 4" *ngIf="UserRole == 4">
                            <button (click)="tab = 4" class="tab-font" [class.active-btn]="tab == 4">
                                Business Information
                                <img class="p-2" *ngIf="tab == 4" src="assets/img/svg/left-arrow.svg">
                            </button>
                        </li>
                        <li class="nav-item" [class.active-btn]="tab == 1" *ngIf="UserRole !== 5">
                            <button (click)="tab = 1" class="tab-font" [class.active-btn]="tab == 1">
                                Personal Information
                                <img class="p-2" *ngIf="tab == 1" src="assets/img/svg/left-arrow.svg">
                            </button>
                        </li>
                        <li class="nav-item" [class.active-btn]="tab == 2" *ngIf="UserRole == 4">
                            <button (click)="tab = 2" class="tab-font" [class.active-btn]="tab == 2">
                                Banking Information
                                <img class="p-2" *ngIf="tab == 2" src="assets/img/svg/left-arrow.svg">
                            </button>
                        </li>
                        <li class="nav-item" [class.active-btn]="tab == 3" *ngIf="UserRole == 4">
                            <button (click)="tab = 3" class="tab-font" [class.active-btn]="tab == 3">
                                Verification Information
                                <img class="p-2" *ngIf="tab == 3" src="assets/img/svg/left-arrow.svg">
                            </button>
                        </li>
                        <li class="nav-item" [class.active-btn]="tab == 13" *ngIf="UserRole == 4">
                            <button (click)="tab = 13" class="tab-font" [class.active-btn]="tab == 13">
                                Alternate Contact
                                <img class="p-2" *ngIf="tab == 13" src="assets/img/svg/left-arrow.svg">
                            </button>
                        </li>

                        <li class="nav-item" [class.active-btn]="tab == 5">
                            <button (click)="tab = 5" class="tab-font" [class.active-btn]="tab == 5">
                                Change Password
                                <img class="p-2" *ngIf="tab == 5" src="assets/img/svg/left-arrow.svg">
                            </button>
                        </li>
                        <li *ngIf="UserRole !== 5 && doctorSettings && doctorSettings['show_subscription'] == 1"
                            class="nav-item" [class.active-btn]="tab == 11">
                            <button (click)="tab = 11" class="tab-font" [class.active-btn]="tab == 11">
                                Subscription Details
                                <img class="p-2" *ngIf="tab == 11" src="assets/img/svg/left-arrow.svg">
                            </button>
                        </li>
                        <li class="nav-item" [class.active-btn]="tab == 12"
                            *ngIf="UserRole !== 5 && userProfileData2 && userProfileData2?.new_dispute_count_total">
                            <button (click)="tab = 12;changeRoute()" class="tab-font" [class.active-btn]="tab == 12">
                                <span class="d-inline-flex align-items-center">
                                    Disputes
                                    <span class="text-danger d-inline-flex align-items-center ms-2"
                                        *ngIf="userProfileData2?.new_dispute_count > 0">
                                        <span class="fs-24 me-1">&#183;</span>{{userProfileData2?.new_dispute_count}}
                                        new</span>
                                </span>
                                <img class="p-2" *ngIf="tab == 12" src="assets/img/svg/left-arrow.svg">
                            </button>
                        </li>
                        <li class="nav-item">
                            <button (click)="logout()" class="tab-font">Logout
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    
    <div class="col-xl-9 col-lg-8 col-12 right-sidedata" [ngClass]="{'px-0': tab==12}">
        <div class="right-top border-0 px-xl-5 ms-xl-5 rounded-0" *ngIf="tab == 1 || tab == 6">
          <form [formGroup]="profileForm" class="form-cont" *ngIf="!isLocationManager">
            <div class="row g-0">
              <div class="col-xl-8 col-12 py-xl-4">
                        <h3
                            style=" font-weight: 700;font-size: 18px;margin-bottom: 1.5rem;display: flex; align-items: center;color: #313A44;">
                  Personal Information
                </h3>
                <div class="row" *ngIf="UserRole !== 4">
                  <!-- First Name Field  -->
                  <div class="col-12 col-md-6 mb-3">
                    <div class="form-group">
                      <div
                        [ngClass]="[profileForm.controls.fname.touched && profileForm.controls.fname.invalid ? 'custom-form  flex-grow-1 me-md-3   inputContainer' : 'custom-form flex-grow-1 me-md-3   ']">
                        <input type="text" class="form-control input_field px-3 pt-3" formControlName="fname" required
                          trim maxlength="25" />
                        <label for="text" class="label-name"><span
                            class="content-name f-c-p-3">{{ label.FIRSTNAME }}</span></label>
                      </div>
                      <p class="mat-error"
                        *ngIf="profileForm.controls.fname.touched &&profileForm.controls.fname.invalid">
                        Please enter Your First Name.</p>
                    </div>
                  </div>
                  <!-- First Name Ends -->
                  <!-- Field Last Name Start -->
                  <div class="col-12 col-md-6 mb-3">
                    <div class="form-group">
                      <div
                        [ngClass]="[profileForm.controls.lname.touched && profileForm.controls.lname.invalid ? 'custom-form  flex-grow-1 me-md-3   inputContainer' : 'custom-form flex-grow-1 me-md-3   ']">
                        <input type="text" class="form-control input_field px-3 pt-3" formControlName="lname" required
                          trim maxlength="25" />
                        <label for="text" class="label-name"><span
                            class="content-name f-c-p-3">{{ label.LASTNAME }}</span></label>
                      </div>
                      <p class="mat-error"
                        *ngIf="profileForm.controls.lname.touched && profileForm.controls.lname.invalid">
                        Please enter your last name.</p>
                    </div>
                  </div>
                  <!-- Field Last Name Ends -->
                </div>

                <!-- Phone Starts -->
                <div class="row" *ngIf="UserRole !== 4">
                  <div class="col-12 mb-3">
                    <div class="form-group">
                      <div
                                    [ngClass]="[profileForm.controls.phone && profileForm.controls.phone.touched && profileForm.controls.phone.invalid  ? 'inputContainer custom-form' : 'custom-form']">
                        <span
                          *ngIf="profileForm.controls.phone &&  (profileForm.controls.phone.value !== null && profileForm.controls.phone.value !== '')"
                          class="pt-2 pe-1 fw-bold dollar_input"
                          style="position: absolute;left: 14px;bottom: 8px;">+1
                        </span>
                        <input type="text" class="form-control input_field pt-3"
                          [ngStyle]="{'padding-left': profileForm.value.phone !== '' ? '40px' : '1rem'}" 
                          name="phone" [formControl]="profileForm.controls['phone']" [mask]="phone_mask" 
                          required />
                                    <label for="text" class="label-name">
                                        <span class="content-name f-c-p-3">
                                            {{ label.PHONE }}
                                        </span>
                                    </label>
                      </div>
                      <p class="mat-error"
                        *ngIf="(profileForm.controls.phone.invalid && profileForm.controls.phone.touched) || (profileForm.controls.phone.invalid && profileForm.controls.phone.dirty)">
                        Please enter your Phone Number</p>
                    </div>
                  </div>
                </div>
                <!-- Phone Ends -->

                <!-- Email Div starts -->
                <div class="row gy-3" *ngIf="UserRole !== 4">
                  <div class="col-12">
                    <div
                      [ngClass]="[profileForm.controls.email.touched && profileForm.controls.email.invalid ? 'custom-form inputContainer' : 'custom-form']">
                      <input class="input_field px-3 pt-3" formControlName="email" readonly required trim />
                      <label for="text" class="label-name">
                        <span class="content-name f-c-p-3">{{ label.EMAIL }}</span>
                      </label>
                    </div>
                    <p class="mat-error"
                      *ngIf="profileForm.controls.email.touched && profileForm.controls.email.invalid">
                      Please enter Your Email.
                    </p>
                  </div>
                </div>
                <!-- Email Div Ends -->

                <!-- upper for admin only and Profle view Common -->

                <!-- UserRole Doctor this will appear -->
                <div class="row gy-3" *ngIf="UserRole === 4">
                  <div class="col-md-6">
                    <div
                      [ngClass]="[profileForm.controls.fname.touched && profileForm.controls.fname.invalid ? 'custom-form inputContainer' : 'custom-form']">
                      <input class="input_field px-3 pt-3" formControlName="fname" required trim maxlength="25" />
                      <label for="text" class="label-name">
                        <span class="content-name f-c-p-3">
                            {{ label.FIRSTNAME }}
                        </span>
                    </label>
                    </div>
                    <p class="mat-error"
                      *ngIf="profileForm.controls.fname.touched &&profileForm.controls.fname.invalid">
                      Please enter your first name.
                    </p>
                  </div>
                  <!-- FistName Ends -->

                  <!-- LastName Starts -->
                  <div class="col-md-6">
                    <div
                      [ngClass]="[profileForm.controls.lname.touched && profileForm.controls.lname.invalid ? 'custom-form inputContainer' : 'custom-form']">
                      <input class="input_field px-3 pt-3" formControlName="lname" required trim
                       maxlength="25" />
                      <label for="text" class="label-name">
                        <span class="content-name f-c-p-3">
                            {{ label.LASTNAME }}
                        </span>
                    </label>
                    </div>
                    <p class="mat-error"
                      *ngIf="profileForm.controls.lname.touched && profileForm.controls.lname.invalid">
                      Please enter your last name.
                    </p>
                  </div>
                  <!-- LastName Starts -->

                  <!-- Phone Starts -->
                  <div class="col-12">
                    <div
                      [ngClass]="[profileForm.controls.phone?.touched && profileForm.controls.phone?.invalid ? 'custom-form inputContainer' : 'custom-form']">
                      <span
                        *ngIf="profileForm.controls.phone &&  (profileForm.controls.phone.value !== null && profileForm.controls.phone.value !== '')"
                        class="pt-2 pe-1 fw-bold dollar_input position-absolute"
                        style="left: 14px; bottom: 8px;">+1</span>
                      <input class="input_field pt-3"
                        [ngStyle]="{'padding-left': profileForm.value.phone ? '40px' : '1rem'}" name="phone"
                        [formControl]="profileForm.controls['phone']" [mask]="phone_mask" 
                        required />
                        <label for="text" class="label-name">
                            <span class="content-name f-c-p-3">
                                {{ label.PHONE }}
                            </span>
                        </label>
                    </div>
                    <p class="mat-error"
                      *ngIf="(profileForm.controls.phone.invalid && profileForm.controls.phone.touched) || (profileForm.controls.phone.invalid && profileForm.controls.phone.dirty)">
                      Please enter your Phone Number
                    </p>
                  </div>
                  <!-- Phone Ends -->

                  <!-- Email Starts -->
                  <div class="col-12">
                    <div
                      [ngClass]="[profileForm.controls.email.touched && profileForm.controls.email.invalid ? 'custom-form inputContainer' : 'custom-form']">
                      <input class="input_field px-3 pt-3" formControlName="email" readonly required trim />
                      <label for="text" class="label-name">
                        <span class="content-name f-c-p-3">
                            {{ label.EMAIL }}
                        </span>
                    </label>
                    </div>
                    <p class="mat-error"
                      *ngIf="profileForm.controls.email.touched && profileForm.controls.email.invalid">
                      Please enter Your Email.
                    </p>

                  </div>
                  <div class="col-12 text-end" *ngIf="AlternateEmails?.length < 2">
                    <button type="button" class="alt-mail" (click)="altMailPop()">
                      + Add alternate email
                    </button>
                  </div>

                  <!-- Email Ends -->

                  <div class="col-12 position-relative" *ngIf="AlternateEmails && AlternateEmails.length > 0">
                    <div class="d-flex align-items-center mb-3 border rounded"
                      *ngFor="let mail of AlternateEmails" style="overflow: hidden;background: #fff; border: 1px solid #C3C8CD !important;">
                      <div class="custom-form flex-grow-1">
                        <input class="input_field px-3 pt-3 border-0 whiteBg" readonly trim [value]="mail.alternate_email" />
                        <label for="text" class="label-name">
                            <span class="content-name f-c-p-3 mb-1">
                                Alternate Email
                            </span>
                        </label>
                    </div>
                      <span class="clear_serch" (click)="show_popup();selected_alternate_email = mail.alternate_email;">
                        <mat-icon class="pointer fs-18 fw-bold mt-4 f-c-p-3">more_horiz</mat-icon>
                        <div class="custom_popup py-2 position-absolute"
                          *ngIf="popup == true && mail.alternate_email == selected_alternate_email">
                          <div class="optionDrop px-3 py-2 d-flex justify-content-between slct-box-text"
                            (click)="editEmail(mail)">Edit</div>
                          <div class="optionDrop px-3 py-2 d-flex justify-content-between slct-box-text"
                            (click)="deleteEmail(mail)">Delete</div>
                          <div class="optionDrop px-3 py-2 d-flex justify-content-between slct-box-text"
                            *ngIf="!mail.verified_on" (click)="sendVerificationsEmail(mail)">Send Verification Email
                          </div>
                        </div>
                      </span>
                    </div>
                    <p class="bottom_mail_text">Note: The above alternate email(s) is used for payout updates only.</p>
                  </div>
                <!-- Date Of Birth -->

                  <div class="col-12">
                    <div
                        [ngClass]="[profileForm.controls.DOB.invalid && profileForm.controls.DOB.touched || (profileForm.controls.DOB.invalid && profileForm.controls.DOB.dirty) || mainService.warningText ? 'custom-form inputContainer' : 'custom-form']">
                      <input type="tel" class="input_field px-3 pt-3 notranslate" id="birthdate-numeric"
                        formControlName="DOB" placeholder="MM/DD/YYYY" autocomplete="off" maxlength="12"
                        [mask]="dobMask" (keyup)="mainService.checkDOB($event)">
                        <label for="text" class="label-name">
                            <span class="content-name f-c-p-3">
                                DOB
                            </span>
                        </label>
                    </div>

                    <p class="mat-error"
                      *ngIf="profileForm.controls.DOB.invalid && mainService.warningText.length == 0">
                      Please enter your date of birth.
                    </p>
                    <p class="mat-error">{{ mainService.warningText }}</p>
                  </div>
                  <!-- Date Of Birth -->

                    <!--Select Industry-->

                  <div class="col-12 mt-0">
                    <div class="custom-form">
                      <input class="input_field px-3 pt-3" formControlName="Industry" />
                      <label for="text" class="label-name">
                        <span class="content-name f-c-p-3">
                            {{ label.INDUSTRY }}
                        </span>
                    </label>
                    </div>
                  </div>

                  <!--Select Industry Ends-->

                  <!--Select Sub Industry-->
                  <div class="col-12">
                    <div class="custom-form">
                      <input class="input_field px-3 pt-3" formControlName="Sub_Industry" />
                      <label for="text" class="label-name">
                        <span class="content-name f-c-p-3">
                          {{ label.SUB_INDUSTRY }}
                        </span>
                      </label>
                    </div>
                  </div>
                  <!--Select Sub Industry Ends-->
                  <!-- Address Starts -->
                  <div class="col-md-7">
                    <div
                      [ngClass]="[profileForm.controls.address.touched && profileForm.controls.address.invalid ? 'custom-form inputContainer' : 'custom-form']">
                      <input class="input_field px-3 pt-3" formControlName="address" required trim />
                      <label for="text" class="label-name">
                        <span class="content-name f-c-p-3">
                          {{ label.ADDRESS_1 }}
                        </span>
                      </label>
                    </div>
                    <p class="mat-error"
                      *ngIf="profileForm.controls.address.touched && profileForm.controls.address.invalid">
                      Please enter your address.
                    </p>
                  </div>
                  <!-- Address Ends -->

                  <!-- Zip Starts -->

                  <div class="col-md-5">
                    <div class="custom-form" *ngIf="profileForm.controls.zipCode.disabled">
                      <input class="input_field px-3 pt-3" formControlName="zipCode" name="zipCode" />
                      <label for="text" class="label-name">
                        <span class="content-name f-c-p-3">
                          Zipcode
                        </span>
                      </label>
                    </div>
                    <zip-selector (zipSelected)="getZipselected($event)" [placeholder]="" t="2"
                    *ngIf="!profileForm.controls.zipCode.disabled" [isRequired]="true"
                    id="zipCode" name="zipCode" [model]="zipCode" ngDefaultControl>
                </zip-selector>
                <p *ngIf="profileForm.controls.zipCode.invalid && profileForm.controls.zipCode.touched "
                    class="mat-error">Please enter a valid zip.
                </p>
                  </div>
                  <!-- Zip Ends -->
                  <!-- State Starts -->
                  <div class="col-md-6">
                    <div
                      [ngClass]="[profileForm.controls.State.touched && profileForm.controls.State.invalid ? 'custom-form inputContainer' : 'custom-form']">
                      <input class="input_field px-3 pt-3" formControlName="State" required trim />
                      <label for="text"
                                                [ngClass]="[profileForm.controls.State.value ? 'label-name' : '']">
                                                <span class="content-name f-c-p-3">
                                                    {{ label.STATE }}
                                                </span>
                                            </label>
                    </div>
                    <p class="mat-error"
                      *ngIf="profileForm.controls.State.touched && profileForm.controls.State.invalid">Please enter your
                      state.</p>
                  </div>
                  <!-- State Ends -->

                  <!-- City Starts -->
                  <div class="col-md-6">
                    <div
                      [ngClass]="[profileForm.controls.city.touched && profileForm.controls.city.invalid ? 'custom-form inputContainer' : 'custom-form']">
                      <input class="input_field px-3 pt-3" formControlName="city" required
                                                trim  autocomplete="disbaled" />
                                            <label for="text"
                                                [ngClass]="[profileForm.controls.city.value ? 'label-name' : '']">
                                                <span class="content-name f-c-p-3">
                                                    {{ label.CITY }}
                                                </span>
                                            </label>
                    </div>
                    <p class="mat-error" 
                        *ngIf="profileForm.controls.city.touched && profileForm.controls.city.invalid">
                      Please enter your city.
                    </p>
                  </div>
                  <!-- City Ends -->
                  <!-- Mmber Since -->
                  <div class="col-12">
                    <div class="custom-form">
                      <input class="input_field px-3 pt-3" formControlName="mb_since" />
                                    <label for="text" class="label-name">
                                        <span class="content-name f-c-p-3">
                                            {{ label.MEMBER_SINCE }}
                                        </span>
                                    </label>
                    </div>
                  </div>
                  <!-- Member Since ends-->
                </div>
                <div class="px-1 py-5">
                  <button type="button" button-primary-auth class="px-4 py-0" style="height: 40px;"
                    [disabled]="profileForm.invalid" (click)="submitProfile()">
                    Save
                </button>
                  <button type="button" button-login-secondary class="px-4 py-0 ms-2" style="height: 40px;"
                    (click)="initForm()" *ngIf="profileForm.valid">
                    Reset
                </button>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div class="right-top border-0 px-xl-5 ms-xl-5 rounded-0" *ngIf="tab == 2">
            <div class="col-md-12 py-4 text-center add_bank" *ngIf="bank_error == 1">
                <app-add-bank-account></app-add-bank-account>
            </div>
            <app-accountdetail *ngIf="bank_error == 0"></app-accountdetail>
            <div class="row">
                <div class="col-xl-6">
                    <app-addcard *ngIf="bank_error == 0"></app-addcard>
                </div>
                <div class="col-xl-6 border_right">
                    <app-payouts *ngIf="bank_error == 0"></app-payouts>
                </div>
            </div>

        </div>

        <div class="right-top border-0 px-xl-5 ms-xl-5 rounded-0" *ngIf="tab == 3">
            <div class="col-md-12 py-4 text-center add_bank" *ngIf="bank_error == 1">
                <app-add-bank-account></app-add-bank-account>
            </div>
            <app-businessverification *ngIf="tab == 3 && bank_error == 0"></app-businessverification>
        </div>

        <div class="right-top border-0 px-xl-5 ms-xl-5 rounded-0" *ngIf="tab == 4">
            <div class="col-md-12 py-4 text-center add_bank" *ngIf="bank_error == 1">
                <app-add-bank-account></app-add-bank-account>
            </div>
            <app-business *ngIf="bank_error == 0"></app-business>
            <app-office *ngIf="bank_error == 0"></app-office>
        </div>

        <div class="right-top border-0 px-xl-5 ms-xl-5 rounded-0" *ngIf="tab == 5">
            <app-change-password></app-change-password>
        </div>
        <div class="right-top border-0 rounded-0 subscriptionDetails d-flex justify-content-center"
            *ngIf="tab == 11 && sub_details">
            <div style="width: 550px;">
                <div class="header">
                    Subscription Details
                </div>
                <div class="plan-text mt-4">Your plan</div>
                <div class="card justify-content-between mt-2">
                    <div class="plan d-flex justify-content-between">
                        <span
                            class="plan_name">{{sub_details.sub_name}}<!-- <p class="expired-subs ms-1" *ngIf="sub_details && sub_details.is_grace_period > 0"><b>(expired)</b></p> --></span>
                        <span class="plan_type ms-2"
                            *ngIf="sub_details && sub_details.is_grace_period < 1">{{sub_details.sub_status |
                            titlecase}}</span>
                        <span class="plan_type_grace" *ngIf="sub_details && sub_details.is_grace_period > 0"><b>
                                {{'grace period' | titlecase}}</b></span>
                    </div>
                    <div class="plan_cost mt-1">
                        <b class="notranslate pe-1">${{sub_details.cost_changed_amount}}</b> monthly
                    </div>
                    <div class="d-flex mt-2 align-items-center">
                        <button routerLink='/app/pricing' style="height: 50px;padding: 12px 35px;" button-primary-auth
                            class="button me-3">Change My Plan</button>
                        <button (click)="renewPlan()" style="height: 50px;padding: 12px 35px;"
                            class="button me-3 renew-btn" *ngIf="sub_details && sub_details.is_grace_period > 0">Renew
                            Plan</button>
                        <button (click)="payInAdvance()" style="height: 50px;width:145px;" class="button me-3 renew-btn"
                            *ngIf="sub_details && sub_details.can_advance_payment > 0 && sub_details.is_grace_period < 1 && sub_details.sub_enum != 'FREE'">Pay
                            In Advance</button>
                        <span *ngIf="sub_details.sub_enum != 'FREE'"
                            style="font-weight: 400;font-size: 14px;color: #3F4446;">{{sub_details.days_left}}
                            days remaining</span>
                    </div>
                </div>
                <div class="under-message mt-2"
                    *ngIf="sub_details.sub_status === sub_status.ACTIVE && sub_details.sub_enum != 'FREE' && sub_details.next_sp_id != 1 && ! sub_details.sub_cancel && sub_details.is_grace_period < 1">
                    Your card will automatically be charged ${{sub_details&& sub_details.upcoming_plan ?
                    sub_details.upcoming_plan.sub_cost : sub_details.cost_changed_amount}} on
                    <span class="notranslate">{{sub_details.renewal_date | date}}</span>
                </div>
                <div class="card justify-content-between mt-2"
                    *ngIf="showUpcoming &&sub_details && sub_details.upcoming_plan && sub_details.upcoming_plan.sp_id !=sub_details.sp_id">
                    <div class="plan d-flex">
                        <span class="plan_name">{{sub_details.upcoming_plan['sub_name']}}</span>
                        <span class="plan_type1 ms-2">Upcoming Plan</span>
                    </div>
                    <div class="plan_cost col-12 mt-1">
                        <div class="row">
                            <div class="col-6 p-0">
                                <b>
                                    <span class="notranslate">${{sub_details.upcoming_plan.sub_cost}}</span>
                                    monthly
                                </b>
                            </div>
                            <div class="col-6 mt-lg-n3 mt-sm-3 mt-xl-n3 pe-xl-0 pe-lg-0 pe-sm-0 text-right">
                                <button
                                    style="background: #FFFFFF; border: 1px solid #C3C8CD;border-radius: 8px;cursor: pointer;"
                                    class="px-4 m-0 py-2" (click)="cancelUpdateSubscription()">
                                    <span style="font-weight: 700; font-size: 14px; line-height: 24px;color: #1581E5;">
                                        Keep {{sub_details.sub_name}} Plan
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="payment-details" *ngIf="sub_details && sub_details.last4 && sub_details.next_sp_id != 1">
                    <div class="plan-text mt-4">
                        Payment Method
                    </div>
                    <div class="card payment-card mt-2 d-flex justify-content-between flex-row">
                        <div class="d-flex align-items-center">
                            <img style="width:24px;" class="me-2"
                                [src]="'assets/img/svg/card-type/'+sub_details.brand+'.svg'"
                                *ngIf="sub_details.brand=='MasterCard' || sub_details.brand=='Discover' || sub_details.brand=='JCB' || sub_details.brand=='Visa' || sub_details.brand=='American Express' || sub_details.brand=='UnionPay' || sub_details.brand=='Diners Club'" />
                            <span style="font-weight: 700;font-size: 17px;">**** **** {{sub_details.last4}}</span>
                        </div>
                        <span (click)="addCardPop()"
                            style="font-weight: 700;font-size: 17px;color: #1581e5;cursor: pointer;">Change</span>
                    </div>
                </div>
                <div class="payment-details" *ngIf="(sub_details && !sub_details.last4 && sub_details.sp_id != 1)">
                    <div class="plan-text mt-4">
                        Payment Method
                    </div>
                    <div class="card payment-card mt-2 d-flex justify-content-center" style=" background-color:#E9F1FF"
                        (click)="cancelUpdateSubscription()" role="button">
                        <div class="d-flex align-items-center justify-content-center">
                            <span style="font-weight: 700;font-size: 17px; color: #1581E5; text-align: center;">+ Add
                                Card</span>
                        </div>
                    </div>
                </div>

                <div class="plan-details">
                    <div class="plan-text mt-4">
                        Your plan includes
                    </div>
                    <div class="card payment-card mt-2 d-flex justify-content-between">
                        <div class="d-flex justify-content-between align-items-center">
                            <span style="font-weight: 600;font-size: 16px;color: #3F4446;">Following features are
                                included in your plan</span>
                            <div *ngIf="featuresList.length > 5 && !plan_expanded" (click)="toggleExpand()"
                                class="pointer">
                                <img src="assets/img/png/downArrow.png" style="height: 30px; width: 30px">
                            </div>
                            <div *ngIf="featuresList.length > 5 && plan_expanded" (click)="toggleExpand()"
                                class="pointer">
                                <img src="assets/img/png/Uparrow.png" style="height: 30px; width: 30px">
                            </div>
                        </div>
                        <div class="mt-2">
                            <ng-container *ngFor="let item of featuresList; let i = index">
                                <span
                                    style="font-weight: 400;font-size: 14px;color: #3F4446;cursor: default !important;"
                                    *ngIf="!plan_expanded && i < 5 &&  item.feature_name!='Response Time'">
                                    {{i > 0 && item.feature_name && i < 4 ? ',' : '' }} {{item.feature_name}} <span
                                        style="color: #1581e5;cursor: pointer;" (click)="toggleExpand()">
                                        {{i === 4 ? ' & more' : ''}}
                                </span>
                                </span>
                                <span
                                    style="font-weight: 400;font-size: 14px;color: #3F4446;cursor: default !important;"
                                    *ngIf="!plan_expanded && i < 5 && item.feature_name=='Response Time'">
                                    <span *ngIf="plan_show=='Free'"
                                        style="font-weight: 400;font-size: 14px;color: #3F4446;">
                                        <span class="notranslate">{{i>0 ? ',': ''}}</span> Response Time within 72
                                        business hours
                                    </span>
                                    <span *ngIf="plan_show=='Silver'"
                                        style="font-weight: 400;font-size: 14px;color: #3F4446;">
                                        <span class="notranslate">{{i>0 ? ',': ''}}</span> Response Time within 48
                                        business hours
                                    </span>
                                    <span *ngIf="plan_show=='Gold'"
                                        style="font-weight: 400;font-size: 14px;color: #3F4446;">
                                        <span class="notranslate">{{i>0 ? ',': ''}}</span> Response Time within 24
                                        business hours
                                    </span>
                                    <span *ngIf="plan_show=='Platinum'"
                                        style="font-weight: 400;font-size: 14px;color: #3F4446;">
                                        <span class="notranslate"><span class="notranslate">{{i>0 ? ',':
                                                ''}}</span></span> Response Time within 15 mins during business hours
                                    </span>
                                    <span style="color: #1581e5;cursor: pointer;" (click)="toggleExpand()">{{i === 4 ? '
                                        & more' : ''}}
                                    </span>
                                </span>
                                <div *ngIf="plan_expanded && item.feature_name!='Response Time'"
                                    class="d-flex align-items-center mb-1">
                                    <span>
                                        <img src="assets/img/png/tick2.png" style=" height: 26px; width: 26px;">
                                    </span>
                                    <span class="ms-3" style="font-weight: 400;font-size: 14px;color: #3F4446;">
                                        {{item.feature_name}}
                                    </span>

                                </div>
                                <div *ngIf="plan_expanded && item.feature_name=='Response Time'"
                                    class="d-flex align-items-center mb-1">
                                    <span>
                                        <img src="assets/img/png/tick2.png" style=" height: 26px; width: 26px;">
                                    </span>
                                    <span class="ms-3" *ngIf="plan_show=='Free'"
                                        style="font-weight: 400;font-size: 14px;color: #3F4446;">
                                        Response Time within 72 business hours
                                    </span>
                                    <span class="ms-3" *ngIf="plan_show=='Silver'"
                                        style="font-weight: 400;font-size: 14px;color: #3F4446;">
                                        Response Time within 48 business hours
                                    </span>
                                    <span class="ms-3" *ngIf="plan_show=='Gold'"
                                        style="font-weight: 400;font-size: 14px;color: #3F4446;">
                                        Response Time within 24 business hours
                                    </span>
                                    <span class="ms-3" *ngIf="plan_show=='Platinum'"
                                        style="font-weight: 400;font-size: 14px;color: #3F4446;">
                                        Response Time within 15 minutes during business hours
                                    </span>

                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
                <div class="d-flex mt-2">
                    <div routerLink="/app/pricing" [queryParams]="{type: 'compare_plan'}"
                        style="color: #0A6B89;font-weight: 700;" class="compare_plans pe-1 pointer d-flex">
                        <p class="mb-0 me-1 d-blue">Compare plans </p>
                        <img src="assets/img/png/ArrowRight11.png" class="logo_img">
                    </div>
                </div>
                <div class="payment-details" *ngIf="sub_details.billing_list && sub_details.billing_list.length">
                    <div class="plan-text mt-3">
                        Billing History
                    </div>
                    <div class="billing-card mt-2 d-flex justify-content-between flex-row w-100"
                        style="max-height: 320px;overflow: auto !important;">
                        <table class="w-100">
                            <thead>
                                <th>Date</th>
                                <th>Details</th>
                                <th>Card</th>
                                <th>Amount</th>
                                <th>Payment Status</th>

                            </thead>
                            <tbody>
                                <tr *ngFor="let bill of sub_details.billing_list">
                                    <td class="notranslate">
                                        {{bill.created | date}}
                                    </td>
                                    <td>
                                        {{bill.sub_name}}
                                    </td>
                                    <td class="d-flex justify-content-start align-items-center"><img style="width:24px;"
                                            class="me-2" [src]="'assets/img/svg/card-type/'+bill.brand+'.svg'"
                                            *ngIf="bill.brand=='MasterCard' || bill.brand=='Discover' || bill.brand=='JCB' || bill.brand=='Visa' || bill.brand=='American Express' || bill.brand=='UnionPay'|| bill.brand=='Diners Club'" />
                                        **** **** {{bill.last4}}
                                    </td>
                                    <td class="notranslate">
                                        ${{bill.cost_deducted.toFixed(2)}}
                                    </td>
                                    <td class="text-center">{{bill.payment_status=='SUCCESS'?'Success':'Failed'}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div *ngIf="sub_details.sub_status == sub_status.ACTIVE && sub_details.sub_enum != 'FREE'"
                    style="color: red;font-weight: 600;font-size: 17px;padding-bottom: 50px;"
                    class="d-inline-block mt-4 mt-2 cursor">
                    <span *ngIf="!sub_details.sub_cancel" class="pointer" routerLink="/app/cancel-subscription">
                        Cancel your subscription
                    </span>
                    <span *ngIf="sub_details.sub_cancel" class="pointer" (click)="changeSubscription(2)">
                        Restore subscription
                    </span>
                </div>
            </div>
        </div>
        <!-- Page for disputed payments -->
        <ng-container *ngIf="tab == 12">
            <app-dispute-list></app-dispute-list>
        </ng-container>
        <!-- Page for disputed payments -->

        <ng-container *ngIf="tab==13">
            <app-alternate-contact></app-alternate-contact>
        </ng-container>
        
         
    </div>
</div>

<div *ngIf="subscription_cancel" class="d-flex justify-content-center align-items-center w-100 text-center"
    style="height: 100vh;">
    <div style="width: 100%;max-width: 515px;">
        <img src="assets\img\gif\right_mark11.gif" alt="" style="width: 100%;max-width: 200px;border-radius: 169px;"
            class="mb-3">
        <h4 class="f-w-800 ps-4 pe-4" style="line-height: 32px;font-size: 24px;">We’re sad to see you go</h4>

        <p class="pay-text fs-16 mt-2">
            You have opted to cancel your <span class="pay-label-text">{{sub_details.sub_name}} Plan</span> and switch
            to the <span class="pay-label-text">Free plan</span>.
            Please be aware that you will still have access to all of your <span
                class="pay-label-text">{{sub_details.sub_name}} Plan</span> features until
            <span class="pay-label-text notranslate">{{calculateYesterdayDate(sub_details.renewal_date) | date}}</span>.
            After that date, your card will not be charged for any subscription fees.
        </p>

        <button button-primary-auth routerLink='app/dashboard'>Go To Dashboard</button>
    </div>
</div>

<div *ngIf="subscription_restore" class="d-flex justify-content-center align-items-center w-100 text-center"
    style="height: 100vh;">
    <div style="width: 100%;max-width: 535px;">
        <img src="assets\img\gif\right_mark11.gif" alt="" style="width: 100%;max-width: 200px;border-radius: 169px;"
            class="mb-3">
        <h4 class="f-w-800 ps-4 pe-4" style="line-height: 32px;font-size: 24px;">Your <span
                style="color:#1581e5">{{sub_details.sub_name}} Plan</span>
            subscription plan has been successfully restored.
        </h4>
        <p class="pay-text fs-16 mt-2">You can continue to enjoy all the features that come with it. <br>
            Please note that on <span class="pay-label-text notranslate">{{sub_details.renewal_date | date}}</span>,
            your card will
            be charged
            <span class="pay-label-text">${{sub_details.cost_changed_amount}}</span> for the next billing cycle.
        </p>
        <button button-primary-auth routerLink='app/dashboard'>Go To Dashboard</button>
    </div>
</div>